module.exports = __webpack_public_path__ + "static/media/bg-boost-desktop.dc8b886b.svg";